import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


//--------------------------------------------------------------------
// GENERAL TOASTERS
//--------------------------------------------------------------------
export const ShowUserSessionExpiredNotificationWarning = (translateFunc) =>
  toast.warning(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{translateFunc("refactored:toastr.general.userTokenExpired")}</p>, {
    position: toast.POSITION.TOP_RIGHT,
    hideProgressBar: true,
  });

  export const ShowToastUserSessionRefreshSuccess = (translateFunc) =>
  toast.success(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{translateFunc("refactored:toastr.general.userTokenRefreshSuccess")}</p>, {
    position: toast.POSITION.TOP_RIGHT,
    hideProgressBar: true,
  });

export const ShowToastUserSessionRefreshError= (translateFunc) =>
toast.error(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{translateFunc("refactored:toastr.general.userTokenRefreshError")}</p>, {
  position: toast.POSITION.TOP_RIGHT,
  hideProgressBar: true,
});



//--------------------------------------------------------------------
// VOUCHER TOASTERS
//--------------------------------------------------------------------

export const ShowToastCampaignsFormValidationFailed = (translateFunc) =>
  toast.info(
    <p className="mx-2 tx-16 d-flex align-items-center mb-0 ">
      {translateFunc("vauchers.toastr.formCheck")}
    </p>,
    {
      position: toast.POSITION.TOP_RIGHT,
      hideProgressBar: true,
    }
  );


export const ShowSuccessVoucherToastMessage = (translateFunc) =>
  toast.success(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{translateFunc("notifications.voucherImageSuccess")}</p>, {
    position: toast.POSITION.TOP_RIGHT,
    hideProgressBar: true,
  });

export const ShowFailedVoucherToastMessage = (translateFunc) =>
  toast.error(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{translateFunc("notifications.voucherImageError")}</p>, {
    position: toast.POSITION.TOP_RIGHT,
    hideProgressBar: true,
  });

export const ShowSuccessHeroToastMessage = (translateFunc) => {
  toast.success(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{translateFunc("notifications.heroImageSuccess")}</p>, {
    position: toast.POSITION.TOP_RIGHT,
    hideProgressBar: true,
  });
};

export const ShowFailedHeroToastMessage = (translateFunc) =>
  toast.error(<p className="mx-2 tx-16 d-flex align-items-center mb-0 ">{translateFunc("notifications.heroImageError")}</p>, {
    position: toast.POSITION.TOP_RIGHT,
    hideProgressBar: true,
  });
